const late_for_party = `Hey there, I'm really sorry, but I won't be able to make it to your birthday party until around eight.
I have an important family commitment that I can't miss, but I'll do my best to get there as soon as I can.
I apologize for being late and I'm really looking forward to celebrating with you.
See you at eight!`;

export default late_for_party;